import React from 'react';
import { withContext } from '@simpledotink/error-boundary';
import { useNotionContext } from '../context';
import { ErrorComponent } from './error-component';
export default function ErrorBoundary(_a) {
    var children = _a.children;
    var recordMap = useNotionContext().recordMap;
    var ErrorFallBack = withContext(recordMap || {});
    return (React.createElement(ErrorFallBack, { fallBack: function () { return React.createElement(ErrorComponent, null); } }, children));
}
//# sourceMappingURL=ErrorBoundary.js.map